import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { SharedUiHighlightLabelModule } from '@se-po/shared-ui-highlight-label'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeSpinnerModule } from 'se-fe-spinner'

import { SeFeHeaderModule } from 'se-fe-header'
import { WhoComponent } from './who/who.component'

@NgModule({
  declarations: [WhoComponent],
  exports: [WhoComponent],
  imports: [
    CommonModule,
    SeFeButtonModule,
    SeFeHeaderModule,
    SeFeSpinnerModule,
    SharedUiHighlightLabelModule,
    TranslateModule.forChild({
      isolate: true
    }),
  ],
})
export class SeHouseholdSetupFeatureWhosParticipatingModule {}
